import { useTranslation } from 'react-i18next';

import { SummaryInformation, TSummaryInformation } from '@/ui-kit/SummaryInformation/SummaryInformation';

import { KycInformationSection } from '@/features/kyc/components/userInformation/InformationSection';
import { TSelfSectionKey } from '@/features/kyc/store/types/self.types';

import { useSelfEmployedInformationProps } from '@/features/kyc/hooks/useSelfEmployedInformationProps';
import { IUser } from '@/features/user/store/user.model';

interface IMainInformation {
  user: IUser;
  isSectionOnEdition: (key: TSelfSectionKey) => boolean;
  isSectionEditable: (key: TSelfSectionKey) => boolean;
  toogleSectionEditMode: (key: TSelfSectionKey) => void;
}

export function SelfMainInformation({
  user,
  isSectionOnEdition,
  isSectionEditable,
  toogleSectionEditMode,
}: IMainInformation) {
  const { t } = useTranslation();

  const isMainInformationOnEdition = isSectionOnEdition('mainInformation');
  const isAddressesOnEdition = isSectionOnEdition('address');
  const isContactOnEdition = isSectionOnEdition('contact');

  const {
    mainInformation,
    address,
    isLoading,
    isAddressValid,
    isContactInvalid,
    contact,
    onUpdateUser,
    onCancelEdition,
    isMainInformationInvalid,
  } = useSelfEmployedInformationProps({
    user,
    isMainInformationOnEdition,
    isAddressesOnEdition,
    isContactOnEdition,
  });

  const userInformation: TSummaryInformation = {
    title: t('pages.dashboard.createUser.form.pages.userInformation'),
    sections: [
      {
        component: (
          <KycInformationSection
            section={mainInformation}
            isOnEdition={isMainInformationOnEdition}
            sectionKey="main-information"
            isLoading={isLoading}
            isFormInvalid={isMainInformationInvalid}
            isSectionNotEditable={isSectionEditable('mainInformation')}
            onEdit={() => toogleSectionEditMode('mainInformation')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('mainInformation'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('mainInformation'))}
          />
        ),
      },
      {
        component: (
          <KycInformationSection
            section={address}
            isOnEdition={isAddressesOnEdition}
            sectionKey="address"
            isLoading={isLoading}
            isFormInvalid={isAddressValid}
            isSectionNotEditable={isSectionEditable('address')}
            onEdit={() => toogleSectionEditMode('address')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('address'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('address'))}
          />
        ),
      },
      {
        component: (
          <KycInformationSection
            section={contact}
            isOnEdition={isContactOnEdition}
            sectionKey="contact"
            isLoading={isLoading}
            isFormInvalid={isContactInvalid}
            isSectionNotEditable={isSectionEditable('contact')}
            onEdit={() => toogleSectionEditMode('contact')}
            onSave={() => onUpdateUser(() => toogleSectionEditMode('contact'))}
            onCancel={() => onCancelEdition(() => toogleSectionEditMode('contact'))}
          />
        ),
      },
    ],
  };

  return <SummaryInformation {...userInformation} />;
}
